import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledAboutIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_16313_12462)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 20,
					height: 20,
					fill: "#E32B24"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 8,
					cy: 8,
					r: 4.5,
					stroke: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8 6V8.5",
					stroke: "white",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 8,
					cy: 10,
					r: .5,
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_16313_12462",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				rx: 4,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgFilledAboutIcon);
const Memo = memo(ForwardRef);
export default Memo;
